import * as types from "../../actions/types";
import { createTypes } from "../../actions/createTypes";
import { baseViewForm } from '../utils/baseViewForm';

const initialState = {
  data: [],
  // Request state lives in the store so that a component re-renders when it
  // changes. A module-level flag cannot do that: mutating it triggers no
  // render, so whichever render happened to run first would win forever.
  loading: false,
  loaded: false,
  errors: null,
};

const attachmentRuleForm = baseViewForm(types.ATTACHMENT_RULE_FORM)
const attachmentRuleView = baseViewForm(types.ATTACHMENT_RULE_VIEW, 'view')

const attachmentRules = (state=initialState, action={}) => { 
  switch(action.type){ 
    case createTypes(types.GET_ATTACHMENT_RULE).loading:
      return { ...state, loading: true, errors: null };
    case createTypes(types.GET_ATTACHMENT_RULE).success: 
      return { ...state, data: action.payload, loading: false, loaded: true };
    case createTypes(types.GET_ATTACHMENT_RULE).failure:
      // loaded: true on failure too - otherwise a failed request leaves the
      // page spinning forever instead of showing the error.
      return { ...state, loading: false, loaded: true, errors: action.payload };
    case createTypes(types.ADD_ATTACHMENT_RULE).success: 
      return { 
        ...state, 
        data: [ action.payload, ...state.data ], 
    };
    case createTypes(types.UPDATE_ATTACHMENT_RULE).success: 
      return { 
        ...state, 
        data: state.data.map((_data) => { 
          if(_data.id === action.payload.id) return action.payload;
          return _data;
        }), 
         
    };
    case createTypes(types.DELETE_ATTACHMENT_RULE_BY_ID).success: 
      return { 
        ...state, 
        data: state.data.filter((_data) => { 
          return _data.id !== action.payload.id;
        }), 
         
    };
    
    case createTypes(types.DELETE_BULK_ATTACHMENT_RULE).success: 
      return { 
        data: state.data.filter((data, index) => {
          return !action.payload.includes(data.id);
        })
      };


    case createTypes(types.ADD_ATTACHMENT_RULE).failure: 
    case createTypes(types.UPDATE_ATTACHMENT_RULE).failure: 
    case createTypes(types.GET_ATTACHMENT_RULE).failure: 
    case createTypes(types.DELETE_ATTACHMENT_RULE_BY_ID).failure: 
    case createTypes(types.DELETE_BULK_ATTACHMENT_RULE).failure: 
      return { ...state, error: action.payload };
    default:
      return state
  }
}


const attachmentRuleReducers = { attachmentRuleForm, attachmentRuleView, attachmentRules };
export default attachmentRuleReducers;
